function initInsuranceBlock() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100;
      const insuranceBlock = document.getElementById("shipping-insurance-block");
      const insuranceCheckbox = document.getElementById("add-insurance");
      const insurancePriceEl = document.getElementById("insurance-price");

      if (!insuranceBlock || !insuranceCheckbox) return;

      if (cartTotal > 35) {
        insuranceBlock.style.display = "block";

        let insuranceVariantId = null;
        let insuranceCost = 0;

        if (cartTotal <= 250) { insuranceVariantId = 62427247411549; insuranceCost = 4.50; }
        else if (cartTotal <= 500) { insuranceVariantId = 62427247444317; insuranceCost = 9.00; }
        else if (cartTotal <= 1000) { insuranceVariantId = 62427247477085; insuranceCost = 18.00; }
        else if (cartTotal <= 2000) { insuranceVariantId = 62427247509853; insuranceCost = 36.00; }
        else if (cartTotal <= 3000) { insuranceVariantId = 62427247542621; insuranceCost = 54.00; }
        else if (cartTotal <= 4000) { insuranceVariantId = 62427247575389; insuranceCost = 72.00; }
        else if (cartTotal <= 5000) { insuranceVariantId = 62427247608157; insuranceCost = 90.00; }

        insurancePriceEl.innerText = `Costo assicurazione: € ${insuranceCost.toFixed(2)}`;

        insuranceCheckbox.addEventListener("change", function () {
          fetch("/cart.js")
            .then(res => res.json())
            .then(cart => {
              const alreadyInCart = cart.items.some(i => i.id === insuranceVariantId);
              if (this.checked && !alreadyInCart) {
                fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: insuranceVariantId, quantity: 1 })
                }).then(() => location.reload());
              } else if (!this.checked && alreadyInCart) {
                const item = cart.items.find(i => i.id === insuranceVariantId);
                fetch(`/cart/change.js`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: item.key, quantity: 0 })
                }).then(() => location.reload());
              }
            });
        });
      }
    });
}

document.addEventListener("DOMContentLoaded", initInsuranceBlock);
document.addEventListener("shopify:section:load", initInsuranceBlock);
